/**
 * @generated SignedSource<<8a0c26cc2e2fd32e9a9c80d217dfd25a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type geoLocationContinentListQuery$variables = Record<PropertyKey, never>;
export type geoLocationContinentListQuery$data = {
  readonly africaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly americasAndCaribbeanQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly asiaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly chinaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly europeQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly middleEastQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly northAmericaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly oceaniaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
  readonly russiaAndCentralAsiaQueue: {
    readonly " $fragmentSpreads": FragmentRefs<"geoLocationGroupQueue">;
  } | null | undefined;
};
export type geoLocationContinentListQuery = {
  response: geoLocationContinentListQuery$data;
  variables: geoLocationContinentListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520763"
    }
  }
],
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "geoLocationGroupQueue"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520764"
    }
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520210"
    }
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520211"
    }
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520765"
    }
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520212"
    }
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520215"
    }
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520214"
    }
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "collection_related_topics_520213"
    }
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  (v10/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v13/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortName",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlAlias",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UrlRedirect",
                        "kind": "LinkedField",
                        "name": "urlRedirect",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "toUrl",
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Application",
                        "kind": "LinkedField",
                        "name": "application",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "fullSectionPath",
                            "plural": true,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentSection",
                            "storageKey": null
                          }
                        ],
                        "type": "Section",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flattenTypeIds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LiveArticle",
                            "kind": "LinkedField",
                            "name": "liveArticle",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaywallType",
                                "kind": "LinkedField",
                                "name": "paywallTypes",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "type": "Topic",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "geoLocationContinentListQuery",
    "selections": [
      {
        "alias": "chinaQueue",
        "args": (v0/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520763\"})"
      },
      {
        "alias": "middleEastQueue",
        "args": (v2/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520764\"})"
      },
      {
        "alias": "asiaQueue",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520210\"})"
      },
      {
        "alias": "oceaniaQueue",
        "args": (v4/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520211\"})"
      },
      {
        "alias": "russiaAndCentralAsiaQueue",
        "args": (v5/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520765\"})"
      },
      {
        "alias": "europeQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520212\"})"
      },
      {
        "alias": "africaQueue",
        "args": (v7/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520215\"})"
      },
      {
        "alias": "americasAndCaribbeanQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520214\"})"
      },
      {
        "alias": "northAmericaQueue",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520213\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "geoLocationContinentListQuery",
    "selections": [
      {
        "alias": "chinaQueue",
        "args": (v0/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520763\"})"
      },
      {
        "alias": "middleEastQueue",
        "args": (v2/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520764\"})"
      },
      {
        "alias": "asiaQueue",
        "args": (v3/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520210\"})"
      },
      {
        "alias": "oceaniaQueue",
        "args": (v4/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520211\"})"
      },
      {
        "alias": "russiaAndCentralAsiaQueue",
        "args": (v5/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520765\"})"
      },
      {
        "alias": "europeQueue",
        "args": (v6/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520212\"})"
      },
      {
        "alias": "africaQueue",
        "args": (v7/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520215\"})"
      },
      {
        "alias": "americasAndCaribbeanQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520214\"})"
      },
      {
        "alias": "northAmericaQueue",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v15/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"collection_related_topics_520213\"})"
      }
    ]
  },
  "params": {
    "cacheID": "652ca0cd256d36cd466e1dc29aeb3995",
    "id": null,
    "metadata": {},
    "name": "geoLocationContinentListQuery",
    "operationKind": "query",
    "text": "query geoLocationContinentListQuery {\n  chinaQueue: queue(filter: {name: \"collection_related_topics_520763\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  middleEastQueue: queue(filter: {name: \"collection_related_topics_520764\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  asiaQueue: queue(filter: {name: \"collection_related_topics_520210\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  oceaniaQueue: queue(filter: {name: \"collection_related_topics_520211\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  russiaAndCentralAsiaQueue: queue(filter: {name: \"collection_related_topics_520765\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  europeQueue: queue(filter: {name: \"collection_related_topics_520212\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  africaQueue: queue(filter: {name: \"collection_related_topics_520215\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  americasAndCaribbeanQueue: queue(filter: {name: \"collection_related_topics_520214\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n  northAmericaQueue: queue(filter: {name: \"collection_related_topics_520213\"}) {\n    ...geoLocationGroupQueue\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment geoLocationGroupQueue on Queue {\n  items {\n    edges {\n      node {\n        __typename\n        ... on Topic {\n          entityId\n          ...topicLinkTopic\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n"
  }
};
})();

(node as any).hash = "bd1eedce32b0550d0a896625caf41771";

export default node;
